import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from '@estee/elc-service';
import { IJoinNowButton } from '../../interfaces/IProductCTA';
import { StyledJoinNowButton } from './ProductCTAStyles';
import { classes } from '../../utils/Classes';

export const JoinNowButton = translate(['nonLoyaltyUsersLoyaltyEarlyAccessCTALabel'])(
    observer(function JoinNowButton(props: IJoinNowButton) {
        const ShopNowButtonClassNames = classes('join-now-button elc-add-to-bag-button');
        const { onJoinNowClick, translations } = props;
        const { nonLoyaltyUsersLoyaltyEarlyAccessCTALabel } = translations as ITranslationsCollection;

        return (
            <StyledJoinNowButton className={ShopNowButtonClassNames} onClick={onJoinNowClick}>
                {nonLoyaltyUsersLoyaltyEarlyAccessCTALabel}
            </StyledJoinNowButton>
        );
    })
);
